import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import jwt_decode from 'jwt-decode';

const PrivateRoute = ({ component: Component, ...rest }) => (
    <Route {...rest} render={props => {

        let isValidAuthToken = true;
        if (localStorage.getItem('feathers-jwt')) {
            const jwt = jwt_decode(localStorage.getItem('feathers-jwt'));
            const expired = new Date(jwt.exp * 1000);
            const now = new Date();

            if (expired < now) {
              fetch(`${process.env.REACT_APP_SOCKET_SERVER_URL}/auth/refresh`, {
                method: "POST",
                credentials: "include"
              })
                .then((response) => {
                  if (!response || !response.ok) {
                    throw new Error("Refresh failed");
                  }
                  return response.json();
                })
                .then((data) => {
                  isValidAuthToken = true;
                })
                .catch((error) => {
                  localStorage.removeItem("feathers-jwt");
                  window.location.href = "/login"
                });
            }

            return (
                isValidAuthToken
                    ? <Component {...props} />
                    : <Redirect to={{ pathname: '/login', state: { from: props.location } }} />
            )
        }
        else {
            return <Redirect to={{ pathname: '/login', state: { from: props.location } }} />
        }

    }} />
)

export default PrivateRoute;